import type { SessionMessage, SessionSummary } from "./index.js";

export const SESSIONS_LIVE_STREAM_PATH = "/api/sessions/live";

export interface SessionLiveStreamRequest {
  surface: "web" | "mobile";
  sessionIds: string[];
  deviceId?: string;
}

export interface SessionLiveConnectedEvent {
  type: "connected";
  connectionId: string;
  sessionIds: string[];
}

export interface SessionLiveSessionsChangedEvent {
  type: "sessions.changed";
  session: SessionSummary;
}

export interface SessionLiveSessionMessageEvent {
  type: "session.message";
  sessionId: string;
  message: SessionMessage;
}

export type SessionRuntimeEventStream =
  | "lifecycle"
  | "tool"
  | "assistant"
  | "error"
  | "item"
  | "plan"
  | "approval"
  | "command_output"
  | "patch"
  | "compaction"
  | "thinking"
  | (string & {});

export interface SessionLiveRuntimeEvent {
  type: "session.runtime";
  sessionId: string;
  runId: string;
  seq: number;
  stream: SessionRuntimeEventStream;
  ts: number;
  data: Record<string, unknown>;
}

export type SessionLiveEvent =
  | SessionLiveConnectedEvent
  | SessionLiveSessionsChangedEvent
  | SessionLiveSessionMessageEvent
  | SessionLiveRuntimeEvent;
